module.exports = __webpack_public_path__ + "img/5.026b1b71.png";